// タイトルの「ホーム画面に追加」(2026-11-01 オーナー要望「ホーム画面に追加するリンクをトップページに置きたい」)。
// ホーム画面から開くと、アドレスバーの無い全画面・縦固定(assets/share/manifest.webmanifest)で遊べる。
// - Android の Chrome など: ブラウザが beforeinstallprompt をくれたら、ボタンでそのまま「インストール」の確認を出す
// - iPhone・iPad: ページから追加はできないので、共有ボタン →「ホーム画面に追加」の手順を出す
// - Android で確認を出せないとき(ほかのブラウザなど): メニュー →「ホーム画面に追加」の手順を出す
// - もうホーム画面から開いている(standalone)とき・PC では出さない
// 文は src/i18n/ の install.*。見た目は style.css の #install-btn・#install-help。

// どう案内するか: "hidden"(出さない)| "prompt"(ブラウザの確認を出す)| "ios" | "android"(手順を出す)
export function installMode({ ua = "", standalone = false, canPrompt = false, maxTouchPoints = 0 } = {}) {
  if (standalone) return "hidden";
  if (canPrompt) return /Android|iPhone|iPad|iPod/i.test(ua) || maxTouchPoints > 0 ? "prompt" : "hidden";
  // iPadOS の Safari は PC の Mac と同じ名乗りをするので、指で触れるかで見分ける
  if (/iPhone|iPad|iPod/i.test(ua) || (/Macintosh/.test(ua) && maxTouchPoints > 1)) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "hidden";
}

export function setupInstall({ button, help, helpText, closeButton, t }) {
  let deferred = null; // beforeinstallprompt で預かった確認
  let installed = false;
  const standalone = () =>
    installed || globalThis.matchMedia?.("(display-mode: standalone)").matches || globalThis.navigator?.standalone === true;
  const mode = () =>
    installMode({ ua: navigator.userAgent, standalone: standalone(), canPrompt: !!deferred, maxTouchPoints: navigator.maxTouchPoints || 0 });
  const refresh = () => button.classList.toggle("hidden", mode() === "hidden");

  globalThis.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault(); // ブラウザが勝手に出す帯は止めて、タイトルのボタンから出す
    deferred = e;
    refresh();
  });
  globalThis.addEventListener("appinstalled", () => {
    installed = true;
    deferred = null;
    help.classList.add("hidden");
    refresh();
  });

  button.addEventListener("click", async () => {
    const m = mode();
    if (m === "prompt") {
      const e = deferred;
      deferred = null; // 確認は1回しか出せない
      await e.prompt();
      refresh();
      return;
    }
    helpText.textContent = t(m === "ios" ? "install.ios" : "install.android");
    help.classList.remove("hidden");
  });
  closeButton.addEventListener("click", () => help.classList.add("hidden"));
  help.addEventListener("click", (e) => {
    if (e.target === help) help.classList.add("hidden"); // 枠の外を押しても閉じる
  });
  refresh();
}
